import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/about";
import { siteInfo } from "@/mocks/site";

export default function AboutVoice() {
  return (
    <>
      <section className="bg-background-50 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl mb-10">
            <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">投稿人反馈</p>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              他们最在意的，是有没有人问「你是谁」
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              以下反馈来自匿名投稿人的授权转述，均已做过脱敏处理，不包含可识别个人的信息。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {testimonials.map((item) => (
              <figure
                key={item.author}
                className="bg-background-100 border border-background-200 rounded-lg p-6 flex flex-col"
              >
                <i className="ri-double-quotes-l text-3xl text-primary-300 mb-4" aria-hidden="true"></i>
                <blockquote className="text-sm leading-relaxed text-foreground-700 flex-1">{item.quote}</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-background-200">
                  <p className="text-sm font-medium text-foreground-900">{item.author}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="bg-background-100 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            <div className="lg:col-span-5">
              <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">联系方式</p>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">
                想先聊聊，也可以从这里开始
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
                如果你还不确定自己的信息是否适合提交，可以先发一封简短的邮件说明大概方向。请不要在邮件中附带任何可识别个人身份的材料。
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/submit"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-lock-2-line" aria-hidden="true"></i>
                  匿名投稿
                </Link>
                <Link
                  to="/guide"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap bg-background-50 border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  先看爆料指南
                </Link>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="bg-background-50 border border-background-200 rounded-lg divide-y divide-background-200">
                <div className="flex items-start gap-4 p-6">
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className="ri-mail-line text-lg" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">邮件联系</h3>
                    <a
                      href={`mailto:${siteInfo.email}`}
                      className="mt-1 inline-block text-sm text-primary-700 hover:text-primary-600 transition-colors break-all"
                    >
                      {siteInfo.email}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-6">
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-time-line text-lg" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">回复周期</h3>
                    <p className="mt-1 text-sm text-foreground-600">通常在 {siteInfo.replyWindow}内给出初步回应。</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-6">
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className="ri-user-forbid-line text-lg" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">隐私提醒</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      任何情况下，我们都不需要你提供身份证件、工作证明或可定位到个人的原始文件。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}